var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "greeting-sign-in" }, [
    _c("a", { attrs: { href: _vm.dashboardLink, itemprop: "url" } }, [
      _c("em", { staticClass: "icon-signin-white person-icon" }),
      _vm._v(" "),
      _c("span", { staticClass: "greeting-text" }, [
        _vm._v("\n      " + _vm._s(_vm.label) + "\n    "),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }